module.exports = __webpack_public_path__ + "static/img/indexCB.dd3b250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gyl/indexCB.png
// module id = bYr4
// module chunks = 14 26